import "./index.scss";

export const Skeleton = ({ width, height }) => {
  return (
    <div
      className="skeleton"
      style={{
        width: width || "100%",
        height: height || "200px"
      }}
    />
  );
};
